import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextareaAutosize from 'react-autosize-textarea';
import ErrorText from './ErrorText';
import Label from './Label';

const TextareaInput = ({ name, label, onChange, placeholder, value, inputRef, maxLength, onKeyPress, error, touched, required, autoResize, classes, children }) => {
  const wrapperClass = classNames(`textarea-input form-group ${classes}`, {
    'textarea-input--autoresize': autoResize,
    'form-group--has-error': touched && error,
  });

  return (
    <div className={wrapperClass}>
      <Label name={name} required={required}>{label}</Label>

      {children}

      <div className="field">
        <TextareaAutosize
          id={name}
          name={name}
          className="form-control"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
          innerRef={inputRef}
          onKeyPress={onKeyPress}
        />
      </div>

      {touched && error && <ErrorText>{error}</ErrorText>}
    </div>
  );
};

TextareaInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  inputRef: PropTypes.func,
  maxLength: PropTypes.number,
  onKeyPress: PropTypes.func,
  error: PropTypes.string,
  touched: PropTypes.bool,
  required: PropTypes.bool,
  autoResize: PropTypes.bool,
  classes: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};

export default TextareaInput;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/TextareaInput.js